import {
    GETWALLETOWNERIDNAMELIST_SUCCESS,
    GETWALLETOWNERIDNAMELIST_FAILED,
    RESET_GETWALLETOWNERIDNAMELIST,
    LOADING_GETWALLETOWNERIDNAMELIST,
    NETWORK_ERROR_GETWALLETOWNERIDNAMELIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWALLETOWNERIDNAMELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWALLETOWNERIDNAMELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWALLETOWNERIDNAMELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWALLETOWNERIDNAMELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWALLETOWNERIDNAMELIST:
            return (state = initialState);
        default:
            return state;
    }
};
